/**
 * По какое число у магазина реально есть цифры.
 *
 * Зачем: в шапке уже был индикатор «данные: 5 мин назад» — но это время
 * ПОСЛЕДНЕГО ОБНОВЛЕНИЯ, а не глубина данных. Ozon отдаёт заказы и особенно
 * рекламу с задержкой, поэтому обновление, прошедшее минуту назад, спокойно
 * может привезти цифры позавчерашним числом. Человек видит зелёную точку,
 * считает, что смотрит на свежую неделю, и делает вывод по неполным дням.
 *
 * Даты СВОИ у каждого источника и всегда будут расходиться (реклама отстаёт от
 * заказов) — поэтому одна общая дата тут была бы враньём. Отдаём все, а в
 * интерфейсе показываем самую раннюю: «данные до X» значит «до X полно всё».
 *
 * Здесь только описание и разбор дат — БЕЗ обращения к базе: этот модуль
 * тянет к себе браузерный компонент строки свежести, а вместе с базой в него
 * приехал бы весь better-sqlite3 и страница просто не собралась бы.
 * Чтение из базы — в lib/data-coverage-store.ts.
 */

/** Источники дневных данных, у каждого своя последняя дата. */
export type DataCoverageSource = "orders" | "ads" | "analytics" | "finance";

export type DataCoverage = {
  /** Заказы (product_order_daily) — основной источник, есть всегда. */
  orders: string | null;
  /** Реклама (product_ad_daily) — отстаёт сильнее прочих. */
  ads: string | null;
  /** Аналитика Ozon: показы, конверсии (product_analytics_daily). */
  analytics: string | null;
  /** Финансы: комиссии, логистика (product_finance_daily). */
  finance: string | null;
  /** Пояснения к источникам для подсказки — например, ограничения Ozon без подписки. */
  notes?: string[];
};

/** Даты источников без служебных полей — для «самой ранней/поздней». */
export function coverageDates(coverage: DataCoverage): string[] {
  return (Object.keys(DATA_COVERAGE_LABELS) as DataCoverageSource[])
    .map(key => coverage[key])
    .filter((d): d is string => typeof d === "string" && !!d);
}

/** Подписи источников для подсказки — рядом с датами. */
export const DATA_COVERAGE_LABELS: Record<DataCoverageSource, string> = {
  orders: "Заказы",
  ads: "Реклама",
  analytics: "Аналитика",
  finance: "Финансы",
};

/** Самая ранняя из известных дат: до неё полно всё. Null, если данных нет. */
export function coverageFloor(coverage: DataCoverage): string | null {
  const dates = coverageDates(coverage);
  if (dates.length === 0) return null;
  return dates.reduce((min, d) => (d < min ? d : min));
}
